import React from 'react';
import styled from 'styled-components';
import {
  AgentClientStage,
  AgentLeadStage,
  getClientStageLabel,
  getLeadStageLabel,
} from '../../services/agentPortalService';

type Tone = 'neutral' | 'info' | 'warning' | 'success' | 'error' | 'muted';

const TONES: Record<Tone, { bg: string; fg: string }> = {
  neutral: { bg: 'var(--primary-light)', fg: 'var(--primary-hover)' },
  info: { bg: 'var(--primary-light)', fg: 'var(--primary-hover)' },
  warning: { bg: 'var(--warning-light)', fg: 'var(--warning-color)' },
  success: { bg: 'var(--success-light)', fg: 'var(--success-color)' },
  error: { bg: 'var(--error-light)', fg: 'var(--error-color)' },
  muted: { bg: 'var(--background-secondary)', fg: 'var(--text-secondary)' },
};

const Badge = styled.span<{ $tone: Tone }>`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: ${p => TONES[p.$tone].bg};
  color: ${p => TONES[p.$tone].fg};
`;

const LEAD_TONES: Record<AgentLeadStage, Tone> = {
  [AgentLeadStage.New]: 'info',
  [AgentLeadStage.InProgress]: 'neutral',
  [AgentLeadStage.NotRelevant]: 'muted',
};

const CLIENT_TONES: Record<AgentClientStage, Tone> = {
  [AgentClientStage.InProgress]: 'neutral',
  [AgentClientStage.AwaitingCommittee]: 'warning',
  [AgentClientStage.Approved]: 'success',
  [AgentClientStage.Rejected]: 'error',
  [AgentClientStage.Closed]: 'muted',
};

export const LeadStageBadge: React.FC<{ stage: AgentLeadStage }> = ({ stage }) => (
  <Badge $tone={LEAD_TONES[stage] ?? 'neutral'}>{getLeadStageLabel(stage)}</Badge>
);

export const ClientStageBadge: React.FC<{ stage: AgentClientStage }> = ({ stage }) => (
  <Badge $tone={CLIENT_TONES[stage] ?? 'neutral'}>{getClientStageLabel(stage)}</Badge>
);
